import { createFileRoute } from "@tanstack/react-router"

import { RequirementsStep } from "@/features/membership/application/components/requirements-step"

export const Route = createFileRoute("/membership/apply/requirements")({
  component: RequirementsStep,
})
